class PerformanceService {
    public measureAppLoad(time: number) {
        if ((window as any).ga) {
            (window as any).ga('send', 'timing', 'Performance', 'App load', time, 'Application Start');
        }
    }

    public track(name: string) {
        if (window.performance) {
            window.performance.mark(`${name}-start`);
        }
    }

    public end(name: string, measurementName?: string) {
        if (window.performance) {
            window.performance.mark(`${name}-end`);
            window.performance.measure(name, `${name}-start`, `${name}-end`);
            const entries = window.performance.getEntriesByName(name);
            if (entries && entries.length > 0 && (window as any).ga) {
                const time = entries[entries.length - 1].duration;
                (window as any).ga('send', 'timing', 'Performance', 'Page load', time, measurementName ? measurementName : name);
            }
            window.performance.clearMeasures();
            window.performance.clearMarks();
        }
    }
}

export const performance = new PerformanceService();
